<template>
  <div class="">
    <div
      class="d-flex flex-wrap"
      v-if="!isLoad"
    >
      <p class="not-found-text" v-if="psychologists.length === 0">
        {{
          $vuetify.lang.t(
            "$vuetify.view.psychologists.oops"
          )
        }}
      </p>
      <template v-for="item in psychologists">
        <div :key="item.id" class="psychologist_wrapper" >
          <v-sheet class="psychologist mx-auto my-5 pa-7 pb-8" elevation="0">
            <button
              type="button"
              class="card-favorite"
              :title="isFavorite(item) ? favText('removeFavorite') : favText('addFavorite')"
              :aria-label="isFavorite(item) ? favText('removeFavorite') : favText('addFavorite')"
              :disabled="favoriteBusy === item.id"
              @click.stop.prevent="toggleFavorite(item)"
            >
              <v-icon color="#00A3B7">{{ isFavorite(item) ? "mdi-heart" : "mdi-heart-outline" }}</v-icon>
            </button>
            <div class="d-flex flex-column align-center">
              <!-- <v-img
                class="ma-5 border-rounded align-self-center"
                max-height="160"
                width="160"
                :src="item.photo"
              ></v-img> -->

              <div class="avatar-wrapper ma-5" :class="{ 'avatar-wrapper--video': item.youtube_link }">
                <PsychologistAvatar :profile="item" :size="160" />
              </div>

              <!-- the name is centred in the card, the badge hangs to its right -->
              <div class="psychologist-title">
                <span class="title">{{ item.name + " " + item.surname }}</span>
                <img class="psychologist-title__badge" src="@/assets/images/account-approved.svg">
              </div>
            </div>

            <div class="text-center psychologist-subtitle">
              <ExperienceText :years="item.experience_ages" />
            </div>

            <div v-if="servicePrices(item).length" class="psychologist-price">
              <div v-for="(price, i) in servicePrices(item)" :key="i">
                {{ price.title }}<template v-if="price.duration"> ({{ price.duration }} {{ $vuetify.lang.t('$vuetify.view.publicProfile.minutes') }})</template> - <span class="psychologist-price__amount">{{ formatPrice(price) }}</span>
              </div>
            </div>
            <!-- no tier price any more: nothing is shown until the psychologist fills a price -->
            <div v-else-if="getPsychologistPrice(item) && getPsychologistPrice(item).price" class="psychologist-price">
              {{ $vuetify.lang.t("$vuetify.view.psychDescrModal.session") }}
              {{ getTimeStr }} - {{ getPsychologistPrice(item).price }} ₴
            </div>
            <div class="psychologist-desc">
              <div>
                <div class="desc-title">
                  {{ $vuetify.lang.t("$vuetify.view.psychDescrModal.methodOfWork") }}
                </div>
                <div class="desc-text">
                  <div 
                    v-for="method in item.main_treatment_methods"
                    :key="method"
                  >
                    {{ method }}
                  </div>
                </div>
              </div>
            </div>

            <div>
                <!-- the link covers the whole card (::after), so a click anywhere opens the profile -->
                <a class="card-link" :href="profileUrl(item)">
                  <button class="show-more-btn" tabindex="-1">
                    {{ $vuetify.lang.t("$vuetify.view.psychDescrModal.seeAll") }}
                  </button>
                </a>
                <!-- above the card link: opens the chat with this psychologist -->
                <router-link class="chat-link" :to="{ name: 'chat', query: { to: item.id } }">
                  <v-icon small color="#00A3B7">mdi-message-text-outline</v-icon> Написати
                </router-link>
            </div>
          </v-sheet>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import ExperienceText from '@/components/UI/ExperienceText'
import PsychologistAvatar from '@/components/main/ShowPsychologist/PsychologistAvatar'
import AppServices from '@/services/api/app.services'

// same as on the public page: psychologists' own prices are shown instead of the old tier price
const CURRENCY_SIGNS = { UAH: '₴', USD: '$', EUR: '€' }

export default {
  name: 'Cards',
  props: {
    isLoad: {
      type: Boolean,
      required: true
    }
  },
  components: {
    ExperienceText,
    PsychologistAvatar
  },
  data () {
    return {
      favoriteIds: [],
      favoriteBusy: null
    }
  },
  mounted () {
    AppServices.get('favoriteIds')
      .then((response) => {
        this.favoriteIds = response.data.data
      })
      .catch(() => {})
  },
  updated () {
    //console.log('updated')
    /* const arr = Array.from(this.$refs.name)
    arr.forEach(e => {
      if (e.clientHeight > 64 && e.clientHeight < 100) {
        e.classList.add('title-text-md')
      } else if (e.clientHeight > 100) {
        e.classList.add('title-text-lg')
      }
    }) */
  },
  computed: {
    psychologists () {
      return this.$store.getters['user/getPsychologists']
    },
    getSelectedConsultationType () {
      return this.$store.getters['consultation_type/getSelectedConsultationType']
    },
    getTimeStr () {
      return this.getSelectedConsultationType === 1 ? this.$vuetify.lang.t("$vuetify.view.common.additionTextConsultationType1Time") : this.$vuetify.lang.t("$vuetify.view.common.additionTextConsultationType2Time");
    },
  },
  directives: {
    clamp: {
      inserted(el, binding) {
        applyClamp(el, binding.value || 3);
      },
      componentUpdated(el, binding) {
        applyClamp(el, binding.value || 3);
      }
    }
  },
  methods: {
    favText (key) {
      return this.$vuetify.lang.t(`$vuetify.main.patientDashboard.favorites.${key}`)
    },
    isFavorite (item) {
      return this.favoriteIds.includes(item.id)
    },
    toggleFavorite (item) {
      const adding = !this.isFavorite(item)
      this.favoriteBusy = item.id
      AppServices[adding ? 'post' : 'delete'](adding ? 'addFavorite' : 'removeFavorite', { id: item.id })
        .then(() => {
          this.favoriteIds = adding ? [...this.favoriteIds, item.id] : this.favoriteIds.filter(id => id !== item.id)
        })
        .catch(() => {})
        .finally(() => {
          this.favoriteBusy = null
        })
    },
    // the new public page lives on the site; the old cabinet page is kept for profiles without a slug
    profileUrl (item) {
      return item.public_url || this.$router.resolve({ name: 'psychologists.show', params: { profile_id: item.id } }).href
    },
    servicePrices (profile) {
      return Array.isArray(profile.service_prices) ? profile.service_prices.filter(item => item && item.price) : []
    },
    formatPrice (item) {
      const sign = CURRENCY_SIGNS[item.currency] || '₴'
      const amount = String(Math.round(Number(item.price))).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
      return `${amount} ${sign}`
    },
    getPsychologistPrice (profile) {
      return profile.prices.find(item => item.consultation_type_id === this.getSelectedConsultationType);
    }
  },
  filters: {
    shorten: (val, letters = 1) => val.split('').slice(0, letters).join('')
  }
}

function applyClamp(el, lines) {
  if (typeof window === 'undefined') return;

  const style = window.getComputedStyle(el);
  const lineHeight = parseFloat(style.lineHeight);

  if (!lineHeight || isNaN(lineHeight)) return;

  const maxHeight = lineHeight * lines;
  el.style.maxHeight = maxHeight + 'px';
  el.style.overflow = 'hidden';

  if (el.scrollHeight > el.clientHeight) {
    let words = el.textContent.trim().split(/\s+/);
    let text = "";

    for (let i = 0; i < words.length; i++) {
      const testText = (text + " " + words[i]).trim();
      el.textContent = testText + "…";

      if (el.scrollHeight > el.clientHeight) {
        // повертаємо попередній варіант з багатокрапкою
        el.textContent = text.trim() + "…";
        return;
      }
      text = testText;
    }
  }
}
</script>

<style>
.psychologist_wrapper {
  min-width: 33.33%;
  display: flex;
  justify-content: center;
}
@media (max-width: 1263px) {
  .psychologist_wrapper {
    min-width: 50%;
  }
}
@media (max-width: 828px) {
  .psychologist_wrapper {
    min-width: 100%;
  }
}
</style>

<style lang="scss" scoped>
.avatar-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.not-found-text {
  font-size: 22px;
  text-align: center;
  justify-self: center;
  margin-top: 16px;
  width: 100%;
}
.psychologist {
  /* * {
    font-family: "Inter", sans-serif;
  } */
  
  position: relative;
  cursor: pointer;
  transition: box-shadow 0.2s;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 370px;
}

.psychologist-price {
  font-weight: 400;
  font-size: 15px;
  color: #00A3B7;
  padding: 18px 0;
  border-bottom: 1px solid #00A3B7;
  text-align: center;
  margin: 20px 0 0;
}
/* "1 200 ₴" stays on one line */
.psychologist-price__amount {
  white-space: nowrap;
}
.psychologist-title {
  position: relative;
  max-width: calc(100% - 60px);
  text-align: center;
}
.psychologist-title__badge {
  position: absolute;
  top: 50%;
  left: calc(100% + 10px);
  transform: translateY(-50%);
}
.psychologist-title .title {
  font-weight: 400;
  font-size: 20px;
  color: #575756;
}
.psychologist-subtitle {
  font-weight: 400;
  font-size: 16px;
  color: #575756;
  margin-top: 8px;
}
.psychologist-desc {
  margin-top: 19px;
  font-weight: 400;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  row-gap: 26px;
  flex-grow: 1;
}
.psychologist-desc .desc-title {
  color: #868686;
}
.psychologist-desc .desc-text {
  color: #575756;

  /* overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  max-height: 144px;

  -webkit-box-orient: vertical;
  -webkit-line-clamp: 6;
  display: -webkit-box; */
}
.psychologist:hover {
  box-shadow: 0 6px 24px rgba(0, 163, 183, 0.18);
}
.card-link::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  border-radius: inherit;
}
/* the heart and the photo with a video stay above the card link */
.card-favorite {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #fff;
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 2;
}
.avatar-wrapper--video {
  z-index: 2;
}
.psychologist .show-more-btn {
  max-width: 90%;
  color: #F4F4F4;
  background: #00A3B7;
  padding: 12px;
  display: block;
  width: 100%;
  margin: 29px auto 0px;
  border-radius: 8px;
}
.border-rounded {
  border-radius: 50% !important;
}
.chat-link {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  max-width: 90%;
  margin: 10px auto 0;
  padding: 10px;
  border: 1px solid #00A3B7;
  border-radius: 8px;
  color: #00A3B7;
  text-decoration: none;
  &:hover {
    background: #F2FAFB;
  }
}
.full-width {
  width: 100%;
}
.book-btn {
  color: $lightColor !important;
}
.card-custom {
  max-height: 600px;
  overflow: hidden;
}
.wrapper-title {
  &:hover .title-text-md {
    transform: translateX(-60%);
  }
  &:hover .title-text-lg {
    transform: translateX(-100%);
  }
}
.title-text-md, .title-text-lg {
  white-space: nowrap;
  transition: 1.5s;
}

</style>
